import { useEffect, useRef, useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { Paginator } from "primereact/paginator";
import FilterDropdown from "../../components/filterDropdown/FilterDropdown";
import { LowInventoryViewModel } from "../../viewmodels/lowInventory/LowInventoryViewModel";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";

const LowInventory = (props) => {
  const { logout, addSnackbar } = props;

  const {
    getAllPlus,
    resetFilters,
    filterComponents,
    showErrorModal,
    getLowInventory,
    showFilters,
    products,
    setProducts,
    loading,
    emptyModal,
    setShowFilters,
    filters,
    getWarehouseLocations,
    getClassTypes,
    getCategoryTypes,
    updateProductDiscontinued,
  } = LowInventoryViewModel(logout, addSnackbar);

  const searchRef = useRef();

  const handleSearch = () => {
    getLowInventory(searchRef.current.value, filters);
  };

  var currentPage = 1;
  useEffect(() => {
    getLowInventory(searchRef.current.value, filters);
    getAllPlus();
    getWarehouseLocations();
    getClassTypes();
    getCategoryTypes();
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const [updatingDiscontinuedById, setUpdatingDiscontinuedById] = useState({});

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getLowInventory(searchRef.current.value, filters);
  };

  const bodyProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  const bodyParentTotalWeight = (item) => {
    return (
      <p>
        {item.stock_unit_of_measure === 2
          ? item.total_pieces
          : item.total_weight_in_kg}{" "}
        {item.stock_unit_of_measure_name}
      </p>
    );
  };

  const reorderLimitBody = (item) => {
    return (
      <p>
        {item.reorder_limit} {item.stock_unit_of_measure_name}
      </p>
    );
  };

  const onDiscontinuedToggle = async (item) => {
    const productId = item.product_id;
    const currentValue = Number(item.discontinued) === 1 ? 1 : 0;
    const nextValue = currentValue === 1 ? 0 : 1;

    const updateLocalDiscontinued = (discontinued) => {
      setProducts((prevProducts) => {
        return prevProducts.map((product) =>
          product.product_id === productId
            ? { ...product, discontinued }
            : product,
        );
      });
    };

    updateLocalDiscontinued(nextValue);
    setUpdatingDiscontinuedById((prev) => ({ ...prev, [productId]: true }));

    const result = await updateProductDiscontinued({
      product_id: productId,
      discontinued: nextValue,
    });

    if (!result.success) {
      updateLocalDiscontinued(currentValue);
      showErrorModal(
        "Could not update discontinued status",
        result?.data?.message || "Please try again.",
      );
    }

    setUpdatingDiscontinuedById((prev) => ({
      ...prev,
      [productId]: false,
    }));
  };

  const bodyActions = (item) => {
    const productId = item.product_id;
    return (
      <div className="flex items-center justify-center">
        <input
          type="checkbox"
          checked={Number(item.discontinued) === 1}
          onChange={() => onDiscontinuedToggle(item)}
          disabled={updatingDiscontinuedById[productId]}
          className="h-4 w-4"
        />
        <span className="ml-2 text-sm leading-4">Discontinued</span>
      </div>
    );
  };

  const rowClassName = (rowData) =>
    Number(rowData.discontinued) === 1 ? "bg-gray-100" : "";

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-2 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Low in stock inventory
              </h1>
              <div className="mt-2 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchReceivingInvoice"
                    id="searchReceivingInvoice"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by product name or PLU"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>

                <FilterDropdown
                  actionCall={() => getLowInventory("", filters)}
                  filterComponents={filterComponents}
                  resetFilters={() => {
                    resetFilters();
                  }}
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                />
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="overflow-hidden card-custom">
                    <DataTable
                      value={products}
                      dataKey="plu"
                      tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
                      cellClassName="p-2 border-1-bottom-gray text-sm"
                      rowClassName={rowClassName}
                    >
                      <Column
                        header="Product Name"
                        body={bodyProductName}
                        style={{ width: "7%" }}
                      />
                      <Column
                        header="Reorder limit"
                        body={reorderLimitBody}
                        style={{ width: "2%" }}
                      />
                      <Column
                        header="Total Weight"
                        body={bodyParentTotalWeight}
                        style={{ width: "5%" }}
                      />

                      <Column
                        header=""
                        body={bodyActions}
                        style={{ width: "5%" }}
                      />
                    </DataTable>
                  </div>
                )}
              </div>
              <div className="w-full">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={products.total}
                  onPageChange={handlePagination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LowInventory),
);
